// extracted by mini-css-extract-plugin
export default {"title":"EducationView_title__bH3Ci","description":"EducationView_description__5WNxT","content":"EducationView_content__IlI3j"};